var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 51 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EADF1",
    d: "M25.292 0v39.475H2.966c-2.405 0-3.807-2.716-2.413-4.676z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#89D22E",
    d: "M39.324 19.737 50.032 34.8c1.393 1.96-.008 4.676-2.413 4.676H25.292l14.032-19.738Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#103C68",
    d: "M39.324 19.737 25.292 0h22.326c2.405 0 3.807 2.716 2.413 4.676z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M25.292 39.475V0l14.032 19.737z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-icon_svg__a",
    width: 15,
    height: 40,
    x: 25,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M25.292 39.475V0l14.032 19.737z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2399EE",
    d: "M25.292 39.475V0l12.83 39.475z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-icon_svg__b",
    width: 26,
    height: 21,
    x: 25,
    y: 19,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#89D22E",
    d: "M39.324 19.737 50.032 34.8c1.393 1.96-.008 4.676-2.413 4.676H25.292l14.032-19.738Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#79BF21",
    d: "m25.292 0 12.83 39.475h-12.83z"
  }))));
};
export { SvgLogoIcon as ReactComponent };
export default "/images/logo-icon.svg";